import { useState, type JSX } from 'react';

import { Button, Icon, Modal, Typography } from '@bookora/ui';

import { SupportDialog } from '@/components/support-contact';

import { helpNoteFor } from './help-notes';
import { openGuideHub } from './runtime';
import { RUNTIME_COPY } from './runtime-copy';
import { useTourStore } from './tour-store';

/**
 * «کمک برای همین صفحه» — the page's help notes (`help-notes.ts`), with the
 * two ways further: the hub and support. Opened from the Help menu on a page
 * without a tour, and by a help offer there (critic C6). The dialog's heading
 * is its accessible name.
 */
export function HelpNotesDialog(): JSX.Element {
  const section = useTourStore((s) => s.helpNotes);
  const setHelpNotes = useTourStore((s) => s.setHelpNotes);
  const [supportOpen, setSupportOpen] = useState(false);
  const note = helpNoteFor(section);
  const close = (): void => setHelpNotes(null);

  return (
    <>
      <Modal
        open={section !== null}
        onCancel={close}
        title={note?.title ?? RUNTIME_COPY.notes.fallbackTitle}
        width={440}
        destroyOnHidden
        footer={
          <div className="bk-help-notes__actions">
            <Button
              icon={<Icon name="chat" size={16} />}
              onClick={() => {
                close();
                setSupportOpen(true);
              }}
            >
              {RUNTIME_COPY.notes.support}
            </Button>
            <Button
              icon={<Icon name="encyclopedia" size={16} />}
              onClick={() => {
                close();
                openGuideHub(undefined, 'help-menu');
              }}
            >
              {RUNTIME_COPY.notes.hub}
            </Button>
            <Button type="primary" onClick={close}>
              {RUNTIME_COPY.notes.close}
            </Button>
          </div>
        }
      >
        {note ? (
          <ul className="bk-help-notes__list">
            {note.bullets.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        ) : (
          <Typography.Paragraph>{RUNTIME_COPY.notes.fallbackBody}</Typography.Paragraph>
        )}
      </Modal>
      <SupportDialog open={supportOpen} onClose={() => setSupportOpen(false)} />
    </>
  );
}
